module.exports = __webpack_public_path__ + "img/suppler.f2764d1e.png";